import { LEVEL_OVER } from "../../gameStateEventTrigger.js";
/**
 * Game-scoped monitor of the player's health/status
 * intended to monitor health changes and provide
 * user feedback accordingly, as well as game loop
 * changes on certain conditions. Hence this is separate
 * from the player itself.
 *
 * @author Preston Sia (presia27)
 */
export class PlayerHealthMonitor {
    /**
     *
     * @param maxHealth Maximum health of the player (also the default on instantiation)
     * @param healthStep How much to alter the health of the player by default
     */
    constructor(maxHealth, healthStep, eventTrigger, flashFade) {
        this.stateChangeCalled = false;
        this.currentHealth = maxHealth;
        this.maxHealth = maxHealth;
        this.initMaxHealth = maxHealth;
        this.healthStep = healthStep;
        this.initHealthStep = healthStep;
        this.eventTrigger = eventTrigger;
        this.flashFade = flashFade !== null && flashFade !== void 0 ? flashFade : null;
    }
    /**
     * Apply damage based on health step and return the new health value
     */
    damage() {
        this.currentHealth = Math.max(this.currentHealth - this.healthStep, 0);
        if (this.flashFade) {
            this.flashFade.triggerFlash(0.15, 0.15);
            this.flashFade.darken(0.2);
        }
        this.checkHealthState();
        return this.currentHealth;
    }
    /**
     * Apply regeneration based on health step and return the new health value
     */
    regen() {
        this.currentHealth = Math.min((this.currentHealth + this.healthStep), this.maxHealth);
        return this.currentHealth;
    }
    /**
     * Reset health to full state
     */
    resetHealth() {
        this.currentHealth = this.maxHealth;
    }
    /**
     * Reset all state
     */
    resetAll() {
        this.maxHealth = this.initMaxHealth;
        this.healthStep = this.initHealthStep;
        this.currentHealth = this.initMaxHealth;
    }
    /**
     * Get the current health
     * @returns Current health number
     */
    getHealth() {
        return this.currentHealth;
    }
    /**
     * Set health step, minimum 0 maximum (maxHealth)
     * @param step Step number
     */
    setHealthStep(step) {
        this.healthStep = Math.min(Math.max(step, 0), this.maxHealth);
    }
    /**
     * Get the maximum health
     * @returns Max health number
     */
    getMaxHealth() {
        return this.maxHealth;
    }
    /**
     * Set the max health
     * @param maxHealth Max health param (>=0)
     */
    setMaxHealth(maxHealth) {
        this.maxHealth = Math.max(maxHealth, 0);
    }
    /**
     * Check if the health has hit 0 and, if so,
     * trigger a state change
     */
    checkHealthState() {
        if (this.currentHealth <= 0 && !this.stateChangeCalled) {
            const levelStatus = {
                success: false,
                reason: "SOUL STOLEN"
            };
            this.eventTrigger.assertChange(levelStatus, LEVEL_OVER);
            this.stateChangeCalled = true;
        }
    }
}
